import { saveAs } from 'file-saver'
import axios from "axios"
const cancelTokens = {}
/**
 * 按指定长度生成随机字符串uuid
 * @param {长度} len
 */
function uuid2(len = 8) {
  // ABCDEFGHIJKLMNOPQRSTUVWXYZ
  var chars = '0123456789abcdefghijklmnopqrstuvwxyz'.split('')
  var uuid = []
  var i
  const radix = chars.length
  for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)]
  return uuid.join('')
}


// 假设stream是文件流，可以是Base64编码的字符串或Blob对象
function streamToFile(stream, fileName) {

  return new Promise((resolve, reject) => {
      if (typeof stream === 'string') {
          // 如果stream是Base64编码的字符串，需要将其转换为Blob
          let parts = stream.split(';base64,');
          let contentType = parts[0].split(':')[1];
          let raw = window.atob(parts[1]);
          let rawLength = raw.length;
          let uInt8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; ++i) {
              uInt8Array[i] = raw.charCodeAt(i);
          }
          let blob = new Blob([uInt8Array], {type: contentType});
          blob.lastModifiedDate = new Date();
          blob.name = fileName;
          resolve(blob);
      } else if (stream instanceof Blob) {
          // 如果stream已经是Blob对象，直接使用
          stream.lastModifiedDate = new Date();
          stream.name = fileName;
          resolve(stream);
      } else {
          reject(new Error('Invalid stream'));
      }
  });
}


// 获取文件上下文模块
function getContentModules(context) {
  return context.keys().reduce((component, module) => {
    const componentConfig = context(module).default
    const { name: componentName } = componentConfig
    component[componentName] = componentConfig
    return component
  }, {})
}
function downloadBlob(data, fileName) { // 下载导出
  const blob = new Blob([data])
  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, fileName)
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}
function downFile(url, name) {
  return saveAs(url, name)
}
export const blobToObject = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = function() {
      try {
        const obj = JSON.parse(reader.result)
        resolve(obj)
      } catch (error) {
        reject(error)
      }
    }
    reader.onerror = function(error) {
      reject(error)
    }
    reader.readAsText(blob)
  })
}

// 将中文分号替换为英文分号
function processSearchKeyword(keyword) {
  if (typeof keyword !== 'string') {
    return keyword
  }
  const processedText = keyword?.replace(/；/g, ';')
  return processedText
}

// 特殊数组类型回显
export const arrayFormat = (arr, label) => {
  let res = ''
  try {
    res = JSON.parse(arr || '[]')?.join(',')
  } catch (err) {
    res = arr
  }
  return res || label || '--'
}


// 复制函数
function copyText(text) {
  var input = document.createElement('textarea');
  input.value = text;
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);


}

function base64toBlob(base64Data, contentType) {  
  contentType = contentType || '';  
  const sliceSize = 1024;  
  const byteCharacters = atob(base64Data);  
  const byteArrays = [];  

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {  
      const slice = byteCharacters.slice(offset, offset + sliceSize);  

      const byteNumbers = new Array(slice.length);  
      for (let i = 0; i < slice.length; i++) {  
          byteNumbers[i] = slice.charCodeAt(i);  
      }  

      const byteArray = new Uint8Array(byteNumbers);  

      byteArrays.push(byteArray);  
  }  

  const blob = new Blob(byteArrays, { type: contentType });  
  return blob;  
}

export const addPending = (config) => {
  const requestKey = getRequestKey(config)
  if (cancelTokens[requestKey] && (config.url.includes('candidate/queryCandidateList') || config.url.includes('resume/resumeLibraryList'))) {
      cancelTokens[requestKey].cancel('cancel request')
  }
  const source = axios.CancelToken.source()
  cancelTokens[requestKey] = source
  config.cancelToken = source.token
}

export const deletePending = (res) => {
  const requestKey = getRequestKey(res.config)
  if (cancelTokens[requestKey]) {
      delete cancelTokens[requestKey]
  }
}

const getRequestKey = (config = {}) => {
  return config.url + config.method + JSON.stringify(config.params, config.data)
}

export { uuid2, getContentModules, downloadBlob, downFile, processSearchKeyword, streamToFile, copyText, base64toBlob }
